import {
  forwardRef,
  Textarea as ChakraTextarea,
  TextareaProps,
} from '@chakra-ui/react';

const Textarea = forwardRef<TextareaProps, 'textarea'>((props, ref) => (
  <ChakraTextarea {...props} ref={ref} />
));

export type { TextareaProps };
export default Textarea;
